import React from 'react';

const StaticMap = ({address, width = '600', height = '300'} : {address: string, width?: string, height?: string}) => {
  const src = `https://maps.googleapis.com/maps/api/staticmap?size=${width}x${height}&scale=2&format=png&maptype=roadmap&markers=${encodeURIComponent(address)}&key=AIzaSyAhSboelelp1UkQWzNGIR5ctZkMy_b3X3s`;
  return (<img className="rounded-3xl" src={src} alt={address} />);
}

export default StaticMap;
